













import Vue from 'vue';
import { Route, NavigationGuardNext } from 'vue-router';
import _ from './utils';

export default Vue.extend({
  props: {
    layouts: { type: Object, default: () => ({}) },
  },
  data: () => ({
    layoutComponent: (() => {}) as (()=>void) | string,
    hasBackButton: false,
    loadingApp: true,
  }),
  computed: {
    isLoading() {
      return this.loadingApp;
    },
    globalComponents() {
      return (Vue as any)?.options?.components ?? {};
    },
  },
  async beforeMount() {
    Vue.$guards.waitForAppLoad().then(() => {
      // Wait a tick to ensure this is the last waitForAppLoad to finish execution
      setTimeout(() => {
        Vue.$router.beforeResolve(this.layoutingGuard);
        // Initial call needed since Vue Router does not call the guard reliably
        this.layoutingGuard(this.$router.currentRoute, undefined as any, () => {});
        this.loadingApp = false;
      }, 1);
    });
  },
  methods: {
    async layoutingGuard(to: Route, from: Route, next: NavigationGuardNext) {
      let layout;
      let hasBackButton: boolean | undefined;
      try {
        layout = await Vue.$routerUtils.getRouteOption<any>(to, 'layout');
        hasBackButton = await Vue.$routerUtils.getRouteOption<boolean>(to, 'hasBackButton');
      } catch (error) {
        this.$log.error(error);
      }
      this.hasBackButton = hasBackButton ?? false;
      const globalComponentNames = Object.keys(this.globalComponents);
      const defaultLayout = this.globalComponents['layout-default'] ?? this.globalComponents.default;
      let resolvedLayout = layout ?? defaultLayout;
      if (Vue.$config.values['widget-layout']) {
        resolvedLayout = Vue.$config.values['widget-layout'];
      }
      if (_.isObject(resolvedLayout)) {
        // It is possible that there is more than one active layout
        // even with conditional layouts
        const allActiveLayouts = [] as any[];
        Object.keys(resolvedLayout).forEach((key) => {
          let isLayoutActive: boolean | (() => boolean);
          isLayoutActive = resolvedLayout[key];
          if (typeof isLayoutActive === 'function') {
            isLayoutActive = isLayoutActive();
          }
          if (isLayoutActive) {
            allActiveLayouts.push(key);
          }
        });
        resolvedLayout = allActiveLayouts;
      }
      if (_.isArray(resolvedLayout)) {
        resolvedLayout.forEach((layoutName: string) => {
          if (globalComponentNames.includes(layoutName)) {
            resolvedLayout = layoutName;
          }
        });
        if (_.isArray(resolvedLayout)) {
          this.$log.error(`Unable to load any of these layouts [${resolvedLayout.join(', ')}], using default instead`);
          resolvedLayout = defaultLayout;
        }
      }
      if (typeof resolvedLayout === 'string') {
        if (resolvedLayout.startsWith('_')) {
          this.$log.error(`Rename the layout "${resolvedLayout}" to --> "layout-${resolvedLayout.replace('_', '')}"`);
        }
        if (!globalComponentNames.includes(resolvedLayout)) {
          this.$log.error(`Layout "${resolvedLayout}" not found, using default instead`);
          resolvedLayout = defaultLayout;
        }
      }
      try {
        this.layoutComponent = resolvedLayout;
      } catch (error) {
        this.layoutComponent = 'div';
        this.$log.error(`Unable to load "${resolvedLayout}" layout`);
        this.$log.error(error);
      }
      next();
    },
  },
});
